import { CacheKeys, userFilterOptions, userSortOptions } from "../../core/constants/filter";
import FilterLayout from "../../components/layout/filter/FilterLayout";
import { useAclContext } from "../../core/contexts/acl";
import { useState } from "react";
import { useWindowSize } from "../../core/hooks/common/useWindowSize";
import { TABLET_SIZE } from "../../core/constants/common";
import UsersTable from "../../components/main/users/UsersTable";
import RUserTable from "../../components/responsive/main/users/RUserTable";
import { useAdminUsersQuery } from "../../core/services/react-query/user";


const AllAdmins = () => {

    const { width } = useWindowSize()
    const { permissions } = useAclContext()
    const hasDownloadAccess = permissions?.export?.write
    const [users, setUsers] = useState({ data: null, loading: true })

    const onUserQuery = (res) => {
        setUsers(res)
    }
    const Component = width > TABLET_SIZE ? UsersTable : RUserTable

    return (
        <FilterLayout
            query={useAdminUsersQuery}
            options={userFilterOptions}
            onQuerySuccess={onUserQuery}
            cache={CacheKeys.ADMINS}
        >
            {width &&
                <Component
                    data={users}
                />
            }

        </FilterLayout>
    )
}

export default AllAdmins
